/**
 * Route for `affiliate-tiers`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AffiliateTiersPage } from "../features/affiliate-tiers/AffiliateTiersPage";

export const affiliateTiersRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/affiliate-tiers",
	component: AffiliateTiersPage,
});

export default affiliateTiersRoute;
